import React from 'react';
import PortalPageTemplate from './PortalPageTemplate';

const PORTAL_USER_KEY = 'portal_user';

const resolveIsParentUser = () => {
  try {
    const raw = sessionStorage.getItem(PORTAL_USER_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.roles) && parsed.roles.includes('parent');
  } catch {
    return false;
  }
};

const PortalStudentPage = () => {
  const isParentUser = resolveIsParentUser();

  return (
    <PortalPageTemplate
      eyebrow={isParentUser ? 'PARENT' : 'STUDENT'}
      title={isParentUser ? '학부모 포털' : '학생 포털'}
      description={
        isParentUser
          ? '자녀 학습과 학원 안내를 확인할 때 사용하는 학부모 전용 화면이에요.'
          : '타자 연습·기록 등 학생에게 필요한 메뉴로 바로 갈 수 있어요.'
      }
    />
  );
};

export default PortalStudentPage;
